import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../tablet/common/Header';
import Menu from '../../tablet/common/Menu';
import Content from './Content';
import Footer from './Footer';
import FilterForm from './FilterForm';
import SelectSortMenuModal from './SelectSortMenuModal';
import HelpModal from '../common/HelpModal';
import * as SortMenuInfo from '../../../constants/K007/SortMenuInfo';

/**
 * Wrapper
 */
class Wrapper extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sortMenuInfoPachi: SortMenuInfo.SORT_MENU_PACHI,
      sortMenuInfoSlot: SortMenuInfo.SORT_MENU_SLOT,
    };
    this.changeSortOrder = this.changeSortOrder.bind(this);
  }

  changeSortOrder() {
    let sortOrder = 'asc';
    if (this.props.data.sortOrder == 'asc') {
      sortOrder = 'desc';
    }

    this.props.actions.changeSortOrder(sortOrder);
  }

  render() {
    let sortLabel = '';

    let sortInfo = this.state.sortMenuInfoPachi.filter(item => item.key === this.props.data.sortKey);
    if (this.props.data.rate > 2) {
      sortInfo = this.state.sortMenuInfoSlot.filter(item => item.key === this.props.data.sortKey);
    }
    if (sortInfo.length != 0) {
      sortLabel = sortInfo[0].name;
    } else {
      sortLabel = 'アウト';
    }

    const bgImg = { backgroundImage: `url('/img/${BACK_GROUND_IMAGE}')` };

    return (
      <div id="wrapper" className="fix_height sortgroup">
        <Header userName={this.props.data.userName} error={this.props.data.error} comactions={this.props.comactions} />
        <Menu />
        <FilterForm actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />
        <Content data={this.props.data} actions={this.props.actions} comactions={this.props.comactions} />
        <Footer sortOrder={this.props.data.sortOrder} sortLabel={sortLabel} changeSortOrder={(e) => { this.changeSortOrder(e); }} />
        <div id="page_top_content">
          <img className="pagetop_btn_img" src="/img/to_top_btn.svg" alt="page top" />
        </div>
        <HelpModal data={this.props.data} actions={this.props.actions} comactions={this.props.comactions} userGuideUrl={K007_USER_GUIDE_URL} />
        <SelectSortMenuModal data={this.props.data} actions={this.props.actions} comactions={this.props.comactions} />
        <div id="bg" style={bgImg} />
      </div>
    );
  }
}

Wrapper.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired
};

export default Wrapper;
